<template>
  <transition
    enter-active-class="tw-transform tw-ease-out tw-duration-300 tw-transition"
    enter-from-class="tw-translate-y-2 tw-opacity-0 sm:tw-translate-y-0 sm:tw-translate-x-2"
    enter-to-class="tw-translate-y-0 tw-opacity-100 sm:tw-translate-x-0"
    leave-active-class="tw-transition tw-ease-in tw-duration-100"
    leave-from-class="tw-opacity-100"
    leave-to-class="tw-opacity-0"
  >
    <div
      v-if="show"
      @click="handleOpen()"
      class="tw-cursor-pointer tw-fixed tw-top-4 tw-right-4 tw-z-[9999] tw-max-w-sm tw-w-full tw-bg-white dark:tw-bg-[#2a3042] tw-shadow-2xl tw-rounded-2xl tw-pointer-events-auto tw-border tw-border-gray-100 dark:tw-border-gray-800 tw-overflow-hidden tw-group"
    >
      <div class="tw-p-5">
        <div class="tw-flex tw-items-start tw-gap-4">
          <div
            class="tw-flex-shrink-0 tw-h-12 tw-w-12 tw-rounded-2xl tw-bg-blue-50 dark:tw-bg-blue-900/30 tw-flex tw-items-center tw-justify-center tw-transition-transform group-hover:tw-scale-110"
          >
            <i
              class="mdi tw-text-2xl tw-text-blue-600 dark:tw-text-blue-400"
              :class="iconClass"
            ></i>
          </div>
          <div class="tw-flex-1 tw-min-w-0">
            <div class="tw-flex tw-justify-between tw-items-start">
              <p
                class="tw-text-sm tw-font-bold tw-text-gray-900 dark:tw-text-white tw-mb-1"
              >
                {{ title }}
              </p>
              <button
                @click.stop="close"
                class="tw-ml-2 tw-flex-shrink-0 tw-bg-transparent tw-cursor-pointer tw-rounded-full tw-inline-flex tw-text-gray-400 hover:tw-text-gray-600 dark:hover:tw-text-white tw-transition-colors tw-border-none tw-p-1"
              >
                <span class="tw-sr-only">Chiudi</span>
                <i class="mdi mdi-close tw-text-lg"></i>
              </button>
            </div>
            <p
              class="tw-text-[13px] tw-leading-relaxed tw-text-gray-500 dark:tw-text-white/80 tw-mb-0"
            >
              {{ message }}
            </p>
          </div>
        </div>
      </div>
      <!-- Progress bar -->
      <div
        v-if="show"
        class="tw-h-1 tw-bg-blue-600 tw-transition-all tw-duration-[4000ms] tw-ease-linear tw-w-0 tw-animate-progress"
      ></div>
    </div>
  </transition>
</template>

<script>
import { routesEnums } from "@/helpers/enums";
import { mapActions } from "vuex";
import { MODULES } from "@/store/modules-enum";
import { NOTIFICATIONS_ACTIONS } from "@/store/notifications/actions-enum";

export default {
  name: "NotificationToast",
  data() {
    return {
      show: false,
      title: "",
      message: "",
      actionType: null,
      notificationData: null,
      timer: null,
    };
  },
  computed: {
    iconClass() {
      const type = String(
        this.actionType || this.notificationData?.type || ""
      );
      switch (type) {
        case "2":
          return "mdi-tag-outline"; // Promo
        case "3":
          return "mdi-clock-alert-outline"; // Scadenza
        default:
          return "mdi-bell-outline"; // Default
      }
    },
  },
  methods: {
    ...mapActions(MODULES.NOTIFICATIONS, [
      NOTIFICATIONS_ACTIONS.REMOVE_NOTIFICATIONS_BY_TYPE,
    ]),
    display(payload, duration = 5000) {
      this.title = payload.title;
      this.message = payload.body || payload.message;
      this.actionType = payload.type;
      this.notificationData = payload.data || {};
      this.show = true;

      if (this.timer) clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        this.close();
      }, duration);
    },
    close() {
      this.show = false;
      if (this.timer) clearTimeout(this.timer);
    },
    handleOpen() {
      const type = String(
        this.actionType || this.notificationData?.type || ""
      );
      const url = this.notificationData?.url || null;

      if (type && !url) {
        switch (type) {
          case "3":
            this.$router
              .push("/bandi-in-scadenza")
              .catch((err) => {
                if (err.name !== "NavigationDuplicated") throw err;
              });
            break;
          case "2":
            const act = this.notificationData?.act;
            if (act) {
              this.$router
                .push({
                  name: routesEnums.PROFILE,
                  params: { promoCode: act },
                })
                .catch((err) => {
                  if (err.name !== "NavigationDuplicated") throw err;
                });
              this.$root.$emit("promo-activated", act);
            }
            break;
          default:
            break;
        }
      } else if (url) {
        window.open(url, "_blank", "noopener");
      }
      this.close();
    },
  },
};
</script>

<style scoped>
@keyframes progress {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}
.tw-animate-progress {
  animation: progress 4s linear forwards;
}
</style>
